import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.search";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useMemo, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import pickBy from 'lodash/pickBy';
import { useLocalizedHistory } from "./../";
import { queryParse, queryStringify } from './query';
export var getQueryUtil = function getQueryUtil(oldParams) {
  return function (newParams) {
    var mergedParams = _objectSpread({}, oldParams, {}, newParams);

    var filteredParams = pickBy(mergedParams, function (value) {
      return !!value;
    });
    var newQuery = queryStringify(filteredParams);
    return newQuery ? "?".concat(newQuery) : '';
  };
};
/**
 * Returns params parsed from query and setQuery function.
 * Needs to be used inside Router.
 */

export function useQueryUrl() {
  var location = useLocation();
  var history = useLocalizedHistory();
  var params = useMemo(function () {
    return queryParse(location.search.slice(1));
  }, [location]);
  var getQuery = useCallback(getQueryUtil(params), [params]);
  var setQuery = useCallback(function (newParams) {
    var url = getQuery(newParams);
    history.push(url || location.pathname);
  }, []);
  return {
    params: useMemo(function () {
      return params;
    }, [params]),
    setQuery: setQuery,
    getQuery: getQuery
  };
}
export var getString = function getString(value) {
  return typeof value === 'string' ? value : '';
};